module.exports = __webpack_public_path__ + "img/001.fbf1fdec.png";